import { constrain, remap } from "common/math";
import { Waiter } from "common/promises";
import { paths } from "from-start/scene/resources";
import { calculateScreen, MAXIMUM_HEIGHT } from "from-start/screen";
import { Howl } from "howler";
import { html, LitElement } from "lit-element";
import { nothing } from "lit-html";
import { classMap } from "lit-html/directives/class-map";
import { styleMap } from "lit-html/directives/style-map";
const idleState = () => ({ name: "idle" });
const freeTimeState = () => ({ name: "freeTime", remainSeconds: 20 });
export class Overlay extends LitElement {
    constructor() {
        super();
        this.state = idleState();
        this.showBottom = true;
        this.showBottomForVideo = false;
        this.showBottomSticky = true;
        this.showBottomAnimate = false;
        this.sound = new Howl({
            src: [paths.video360ChalkakSound],
        });
        this._hideTop = false;
        this.onResize = this.onResize.bind(this);
        this.showBottomSticky = true;
    }
    static get properties() {
        return {
            showBottom: { type: Boolean },
            showBottomForVideo: { type: Boolean },
            showBottomSticky: { type: Boolean },
        };
    }
    hideTop() {
        this._hideTop = true;
        this.requestUpdate();
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if ("showBottomForVideo".toLocaleLowerCase() === name.toLowerCase()) {
            setTimeout(() => {
                this.showBottomSticky = newVal != null;
                this.requestUpdate();
            }, 1000);
        }
        super.attributeChangedCallback(name, oldVal, newVal);
    }
    _assertState(expected) {
        if (this.state.name !== expected) {
            throw new Error(`Expected ${this.state} to be ${expected}}`);
        }
    }
    /**
     * Valid only in the freeTime state
     */
    get _remainSeconds() {
        this._assertState("freeTime");
        return this.state.remainSeconds;
    }
    /**
     * Valid only in the freeTime state
     */
    set _remainSeconds(second) {
        this._assertState("freeTime");
        this.state.remainSeconds = second;
        this.requestUpdate();
    }
    async startFreeTime(video) {
        this._assertState("idle");
        this.state = freeTimeState();
        this.requestUpdate();
        const space = ((17 + 10 / 30) / 20) * 1000;
        const startTimeMilli = video.currentTime * 1000;
        const goalTimeMilli = startTimeMilli + space * 20;
        const endWaiter = new Waiter();
        const timeupdate = () => {
            const passed = remap({
                value: video.currentTime * 1000,
                start1: startTimeMilli,
                stop1: goalTimeMilli,
                start2: 20,
                stop2: 0,
            });
            const constrained = constrain({ value: passed, min: 0, max: 20 });
            this._remainSeconds = Math.ceil(constrained);
            if (this._remainSeconds === 0) {
                endWaiter.trigger();
            }
            this.requestUpdate();
        };
        const ended = () => {
            endWaiter.trigger();
        };
        video.addEventListener("timeupdate", timeupdate);
        video.addEventListener("ended", ended);
        await endWaiter.wait();
        video.removeEventListener("timeupdate", timeupdate);
        video.removeEventListener("ended", ended);
        this.state = idleState();
        this.requestUpdate();
    }
    onResize() {
        this.requestUpdate();
    }
    createRenderRoot() {
        return this;
    }
    render() {
        const { viewport } = calculateScreen();
        const bottom = (MAXIMUM_HEIGHT - viewport.height) / 2;
        const top = bottom;
        const topStyle = {
            top: `${top}px`,
        };
        const bottomStyle = {
            bottom: `${bottom}px`,
        };
        const bottomChalkakButtonStyle = {
            bottom: `${bottom + 14}px`,
            "background-color": "transparent",
            border: "none",
            //border: "gold 10px solid",
            overflow: "hidden",
            outline: "none",
            left: "307px",
            width: "100px",
            height: "100px",
            "pointer-events": "auto",
        };
        const freeTimeStyle = {
            top: `${top + 18}px`,
            left: "0",
            right: "0",
        };
        const bottomStyleForSelfie = {
            left: "0",
            transition: "all 0.5s linear",
        };
        if (!this.showBottomAnimate) {
            const selfieBottom = 345;
            const beforeBottom = 128;
            bottomStyleForSelfie["bottom"] = `${bottom + beforeBottom - selfieBottom}px`;
            if (this.showBottomForVideo === true &&
                this.showBottomAnimate === false) {
                setTimeout(() => {
                    this.showBottomAnimate = true;
                    this.requestUpdate();
                    console.log("set this.showBottomAnimate to true 100 milliseconds");
                }, 100);
            }
        }
        else {
            bottomStyleForSelfie["bottom"] = "0";
        }
        const topClasses = {
            "o-0": this._hideTop,
        };
        return html `<img
        src="${paths.video360CameraLayerTop}"
        class="fixed transition-1s ${classMap(topClasses)}"
        style=${styleMap(topStyle)}
      />
      ${this.showBottom && this.showBottomSticky
            ? html `<img
              src="${paths.video360CameraLayerBottom}"
              style="${styleMap(bottomStyle)}"
              class="fixed"
            />
            <button
              id="camera-button"
              style="${styleMap(bottomChalkakButtonStyle)}"
              class="fixed"
              @click="${this.onCameraClick}"
            ></button>`
            : nothing}
      ${this.showBottom && this.showBottomForVideo
            ? html `<img
            id="selfieBottom"
            src="${paths.video360CameraLayerBottomForSelfie}"
            style="${styleMap(bottomStyleForSelfie)}"
            class="fixed"
          />`
            : nothing}
      <div
        class="absolute flex justify-around"
        style=${styleMap(freeTimeStyle)}
      >
        <span class="nanum gray f2" style="white-space:nowrap;"
          >${this.state.name === "freeTime"
            ? `Free time : ${String(this._remainSeconds).padStart(2, "0")}`
            : nothing}
        </span>
      </div>`;
    }
    onCameraClick() {
        if (this.state.name === "freeTime") {
            this.sound.play();
            $("jh-camera-flash")[0].trigger();
        }
    }
}
customElements.define("jh-360-video-overlay", Overlay);
//# sourceMappingURL=overlay.js.map